import './addShiftBox.css';
import { Button } from './Button';
import React, { useState } from 'react'
import { RepeatOptions } from './RepeatOptions';

export const AddShiftBox = (props) => {

    const [client, setClient]                   = useState('');
    const [caretaker, setCaretaker]             = useState('');
    const [startDate, setStartDate]             = useState('');
    const [startTime, setStartTime]             = useState('');
    const [endDate, setEndDate]                 = useState('');
    const [endTime, setEndTime]                 = useState('');
    const [comments, setComments]               = useState('');
    const [mileage, setMileage]                 = useState('');
    const [flatFeeCaretaker, setFlatFeeCaretaker] = useState('');
    const [flatFeeClient, setFlatFeeClient]     = useState('');
    const [endTimeError, setEndTimeError]       = useState('');

    const sortedClients = [...props.clientList].sort((a, b) => a.name.localeCompare(b.name));
    const sortedCaretakers = [...props.caretakerList].sort((a, b) => a.name.localeCompare(b.name));

    const gatherFields = async () => {
        let chosenClient = client;
        let chosenCaretaker = caretaker;
        let shiftComments = comments;
        let shiftMileage = mileage === '' ? 0 : mileage;

        if (!chosenClient) { alert('Please select a client.'); return; }
        if (!chosenCaretaker) { alert('Please select a caretaker.'); return; }
        if (!startDate || !startTime) { alert('Please enter a start date and time.'); return; }
        if (!endDate || !endTime) { alert('Please enter an end date and time.'); return; }

        let overnightShift = startDate !== endDate;
        let startDatetime = startDate + "T" + startTime;
        let endDatetime = endDate + "T" + endTime;
        let currDate = new Date(startDatetime);
        let startTimeSecs = currDate.getTime();
        let caretakerFromList = props.caretakerList.filter(c => c.name === chosenCaretaker)[0];

        if (!caretakerFromList) { alert('Caretaker not found in list. Please refresh and try again.'); return; }

        let isRepeatingShift = props.renderRepeatOptions;
        let isFlatFee = props.renderFlatFeeOptions;

        let shiftsToAdd = [];

        if (startDate === endDate && endTime < startTime) {
            setEndTimeError('Error: End time is before start time');
            return;
        }

        // Get the caretakers shift calendar color
        let caretakerColor = caretakerFromList.color;

        // If the shift is not repeating
        if (!isRepeatingShift) {

            // Get next day information
            let nextDayDateTime = new Date(endDatetime);
            const nextDayDateYear = nextDayDateTime.getFullYear();
            let nextDayDateMonth = nextDayDateTime.getMonth() + 1;
            let nextDayDateDay = nextDayDateTime.getDate();

            // pad next day infomation to fit calendar format
            if (nextDayDateMonth.toString().length < 2) {
                nextDayDateMonth = "0" + nextDayDateMonth;
            }
            if (nextDayDateDay.toString().length < 2) {
                nextDayDateDay = "0" + nextDayDateDay;
            }

            // next day timestamp
            const nextDayDateTimestamp = `${nextDayDateYear}-${nextDayDateMonth}-${nextDayDateDay}T${endTime}`;

            // Shift is not repeating, and is a flat fee
            if (isFlatFee) {
                let shiftObj = {
                    chosenClient: chosenClient,
                    chosenCaretaker: chosenCaretaker,
                    startTimeSecs: startTimeSecs,
                    startDatetime: startDatetime,
                    endDatetime: nextDayDateTimestamp,
                    shiftComments: shiftComments,
                    caretakerColor: caretakerColor,
                    shiftRepeat: false,
                    shiftRepeatID: null,
                    isFlatFeeShift: true,
                    flatFeeCaretaker: flatFeeCaretaker,
                    shiftMileage: shiftMileage,
                    flatFeeClient: flatFeeClient
                }
                shiftsToAdd.push(shiftObj);
            } else {
                let shiftObj = {
                    chosenClient: chosenClient,
                    chosenCaretaker: chosenCaretaker,
                    startTimeSecs: startTimeSecs,
                    startDatetime: startDatetime,
                    endDatetime: nextDayDateTimestamp,
                    shiftComments: shiftComments,
                    caretakerColor: caretakerColor,
                    shiftRepeat: false,
                    shiftRepeatID: null,
                    isFlatFeeShift: false,
                    flatFeeCaretaker: null,
                    shiftMileage: shiftMileage,
                    flatFeeClient: null
                }
                shiftsToAdd.push(shiftObj);
            }

        // Shift is repeating, but not an overnight shift
        } else if (isRepeatingShift && overnightShift !== "Yes") {

            let dateInADay = new Date(startDatetime);

            // Get daily repeat checkbox values (still in RepeatOptions child component)
            let mondayRepeat = document.getElementById("mondayRepeat").checked;
            let tuesdayRepeat = document.getElementById("tuesdayRepeat").checked;
            let wednesdayRepeat = document.getElementById("wednesdayRepeat").checked;
            let thursdayRepeat = document.getElementById("thursdayRepeat").checked;
            let fridayRepeat = document.getElementById("fridayRepeat").checked;
            let saturdayRepeat = document.getElementById("saturdayRepeat").checked;
            let sundayRepeat = document.getElementById("sundayRepeat").checked;

            // Array to hold checked/unchecked values for weekly repeat
            let daysOfTheWeekRepeatArray = [];
            daysOfTheWeekRepeatArray.push(sundayRepeat);
            daysOfTheWeekRepeatArray.push(mondayRepeat);
            daysOfTheWeekRepeatArray.push(tuesdayRepeat);
            daysOfTheWeekRepeatArray.push(wednesdayRepeat);
            daysOfTheWeekRepeatArray.push(thursdayRepeat);
            daysOfTheWeekRepeatArray.push(fridayRepeat);
            daysOfTheWeekRepeatArray.push(saturdayRepeat);

            let shiftCount = 0;

            // Get the end cutoff date for repeating shift
            let repeatEndDate = document.getElementById("repeatEndDate").value;
            let repeatEndDateObject = new Date(repeatEndDate);
            repeatEndDateObject.setDate(repeatEndDateObject.getDate() + 1);

            let dateInADayEndTime = new Date(endDatetime);

            const shiftRepeatID = `${currDate.getTime()}--${chosenClient}:${chosenCaretaker}`;
            let repeatFrequency = document.getElementById("repeatFreqSelect").value;

            if (isFlatFee) {
                let shiftObj = {
                    chosenClient: chosenClient,
                    chosenCaretaker: chosenCaretaker,
                    startTimeSecs: startTimeSecs,
                    startDatetime: startDatetime,
                    endDatetime: endDatetime,
                    shiftComments: shiftComments,
                    caretakerColor: caretakerColor,
                    shiftRepeat: true,
                    shiftRepeatID: shiftRepeatID,
                    isFlatFeeShift: true,
                    flatFeeCaretaker: flatFeeCaretaker,
                    shiftMileage: shiftMileage,
                    flatFeeClient: flatFeeClient
                }
                shiftsToAdd.push(shiftObj);
            } else {
                let shiftObj = {
                    chosenClient: chosenClient,
                    chosenCaretaker: chosenCaretaker,
                    startTimeSecs: startTimeSecs,
                    startDatetime: startDatetime,
                    endDatetime: endDatetime,
                    shiftComments: shiftComments,
                    caretakerColor: caretakerColor,
                    shiftRepeat: true,
                    shiftRepeatID: shiftRepeatID,
                    isFlatFeeShift: false,
                    flatFeeCaretaker: null,
                    shiftMileage: shiftMileage,
                    flatFeeClient: null
                }
                shiftsToAdd.push(shiftObj);
            }

            // while date < end date cutoff
            while (dateInADay.getTime() < repeatEndDateObject.getTime()) {

                shiftCount++;

                if (repeatFrequency === "Every Other Week" && shiftCount % 7 === 0) {
                    dateInADay.setDate(dateInADay.getDate() + 8);
                    dateInADayEndTime.setDate(dateInADayEndTime.getDate() + 8);
                } else {
                    dateInADay.setDate(dateInADay.getDate() + 1);
                    dateInADayEndTime.setDate(dateInADayEndTime.getDate() + 1);
                }

                if (daysOfTheWeekRepeatArray[dateInADay.getDay()] === true) {

                    startTimeSecs = dateInADay.getTime();
                    let dateInADayYear = dateInADay.getFullYear();
                    let dateInADayMonth = dateInADay.getMonth() + 1;
                    let dateInADayDate = dateInADay.getDate();
                    let dateInADayHours = dateInADay.getHours();
                    let dateInADayMins = dateInADay.getMinutes();
                    if (dateInADayDate.toString().length < 2) dateInADayDate = "0" + dateInADayDate;
                    if (dateInADayMonth.toString().length < 2) dateInADayMonth = "0" + dateInADayMonth;
                    if (dateInADayHours.toString().length < 2) dateInADayHours = "0" + dateInADayHours;
                    if (dateInADayMins.toString().length < 2) dateInADayMins = "0" + dateInADayMins;

                    let dateInADayFormat = `${dateInADayYear}-${dateInADayMonth}-${dateInADayDate}T${dateInADayHours}:${dateInADayMins}`;

                    let dateInADayEndTimeYear = dateInADayEndTime.getFullYear();
                    let dateInADayEndTimeMonth = dateInADayEndTime.getMonth() + 1;
                    let dateInADayEndTimeDate = dateInADayEndTime.getDate();
                    let dateInADayEndTimeHours = dateInADayEndTime.getHours();
                    let dateInADayEndTimeMins = dateInADayEndTime.getMinutes();
                    if (dateInADayEndTimeDate.toString().length < 2) dateInADayEndTimeDate = "0" + dateInADayEndTimeDate;
                    if (dateInADayEndTimeMonth.toString().length < 2) dateInADayEndTimeMonth = "0" + dateInADayEndTimeMonth;
                    if (dateInADayEndTimeHours.toString().length < 2) dateInADayEndTimeHours = "0" + dateInADayEndTimeHours;
                    if (dateInADayEndTimeMins.toString().length < 2) dateInADayEndTimeMins = "0" + dateInADayEndTimeMins;

                    const dateInADayEndTimeFormat = `${dateInADayEndTimeYear}-${dateInADayEndTimeMonth}-${dateInADayEndTimeDate}T${dateInADayEndTimeHours}:${dateInADayEndTimeMins}`;

                    if (isFlatFee) {
                        shiftsToAdd.push({
                            chosenClient, chosenCaretaker, startTimeSecs,
                            startDatetime: dateInADayFormat, endDatetime: dateInADayEndTimeFormat,
                            shiftComments, caretakerColor, shiftRepeat: true, shiftRepeatID,
                            isFlatFeeShift: true, flatFeeCaretaker, shiftMileage, flatFeeClient
                        });
                    } else {
                        shiftsToAdd.push({
                            chosenClient, chosenCaretaker, startTimeSecs,
                            startDatetime: dateInADayFormat, endDatetime: dateInADayEndTimeFormat,
                            shiftComments, caretakerColor, shiftRepeat: true, shiftRepeatID,
                            isFlatFeeShift: false, flatFeeCaretaker: null, shiftMileage, flatFeeClient: null
                        });
                    }
                }
            }

            props.setRenderRepeatOptions(false);
            props.setRenderFlatFeeOptions(false);

        // Repeating overnight shift
        } else if (isRepeatingShift && overnightShift === "Yes") {

            let nextDayDateTime = new Date(endDatetime);
            const nextDayDateYear = nextDayDateTime.getFullYear();
            let nextDayDateMonth = nextDayDateTime.getMonth() + 1;
            let nextDayDateDay = nextDayDateTime.getDate();
            if (nextDayDateMonth.toString().length < 2) nextDayDateMonth = "0" + nextDayDateMonth;
            if (nextDayDateDay.toString().length < 2) nextDayDateDay = "0" + nextDayDateDay;
            const nextDayDateTimestamp = `${nextDayDateYear}-${nextDayDateMonth}-${nextDayDateDay}T${endTime}`;

            const shiftRepeatID = `${currDate.getTime()}--${chosenClient}:${chosenCaretaker}`;

            let dateInADay = new Date(startDatetime);
            let dateInADayEndTime = new Date(nextDayDateTimestamp);
            let repeatEndDate = document.getElementById("repeatEndDate").value;
            let repeatEndDateObject = new Date(repeatEndDate);
            repeatEndDateObject.setDate(repeatEndDateObject.getDate() + 1);

            let mondayRepeat = document.getElementById("mondayRepeat").checked;
            let tuesdayRepeat = document.getElementById("tuesdayRepeat").checked;
            let wednesdayRepeat = document.getElementById("wednesdayRepeat").checked;
            let thursdayRepeat = document.getElementById("thursdayRepeat").checked;
            let fridayRepeat = document.getElementById("fridayRepeat").checked;
            let saturdayRepeat = document.getElementById("saturdayRepeat").checked;
            let sundayRepeat = document.getElementById("sundayRepeat").checked;

            let daysOfTheWeekRepeatArray = [];
            daysOfTheWeekRepeatArray.push(sundayRepeat);
            daysOfTheWeekRepeatArray.push(mondayRepeat);
            daysOfTheWeekRepeatArray.push(tuesdayRepeat);
            daysOfTheWeekRepeatArray.push(wednesdayRepeat);
            daysOfTheWeekRepeatArray.push(thursdayRepeat);
            daysOfTheWeekRepeatArray.push(fridayRepeat);
            daysOfTheWeekRepeatArray.push(saturdayRepeat);

            let shiftCount = 0;
            let repeatFrequency = document.getElementById("repeatFreqSelect").value;

            if (isFlatFee) {
                shiftsToAdd.push({
                    chosenClient, chosenCaretaker, startTimeSecs,
                    startDatetime, endDatetime: nextDayDateTimestamp,
                    shiftComments, caretakerColor, shiftRepeat: true, shiftRepeatID,
                    isFlatFeeShift: true, flatFeeCaretaker, shiftMileage, flatFeeClient: null
                });
            } else {
                shiftsToAdd.push({
                    chosenClient, chosenCaretaker, startTimeSecs,
                    startDatetime, endDatetime: nextDayDateTimestamp,
                    shiftComments, caretakerColor, shiftRepeat: true, shiftRepeatID,
                    isFlatFeeShift: false, flatFeeCaretaker: null, shiftMileage, flatFeeClient: null
                });
            }

            while (dateInADay.getTime() <= repeatEndDateObject.getTime()) {

                shiftCount++;

                if (repeatFrequency === "Every Other Week" && shiftCount % 7 === 0) {
                    dateInADay.setDate(dateInADay.getDate() + 8);
                    dateInADayEndTime.setDate(dateInADayEndTime.getDate() + 8);
                } else {
                    dateInADay.setDate(dateInADay.getDate() + 1);
                    dateInADayEndTime.setDate(dateInADayEndTime.getDate() + 1);
                }

                startTimeSecs = dateInADay.getTime();

                if (daysOfTheWeekRepeatArray[dateInADay.getDay()] === true) {

                    let dateInADayYear = dateInADay.getFullYear();
                    let dateInADayMonth = dateInADay.getMonth() + 1;
                    let dateInADayDate = dateInADay.getDate();
                    let dateInADayHours = dateInADay.getHours();
                    let dateInADayMins = dateInADay.getMinutes();
                    if (dateInADayDate.toString().length < 2) dateInADayDate = "0" + dateInADayDate;
                    if (dateInADayMonth.toString().length < 2) dateInADayMonth = "0" + dateInADayMonth;
                    if (dateInADayHours.toString().length < 2) dateInADayHours = "0" + dateInADayHours;
                    if (dateInADayMins.toString().length < 2) dateInADayMins = "0" + dateInADayMins;

                    let dateInADayFormat = `${dateInADayYear}-${dateInADayMonth}-${dateInADayDate}T${dateInADayHours}:${dateInADayMins}`;

                    let dateInADayEndTimeYear = dateInADayEndTime.getFullYear();
                    let dateInADayEndTimeMonth = dateInADayEndTime.getMonth() + 1;
                    let dateInADayEndTimeDate = dateInADayEndTime.getDate();
                    let dateInADayEndTimeHours = dateInADayEndTime.getHours();
                    let dateInADayEndTimeMins = dateInADayEndTime.getMinutes();
                    if (dateInADayEndTimeDate.toString().length < 2) dateInADayEndTimeDate = "0" + dateInADayEndTimeDate;
                    if (dateInADayEndTimeMonth.toString().length < 2) dateInADayEndTimeMonth = "0" + dateInADayEndTimeMonth;
                    if (dateInADayEndTimeHours.toString().length < 2) dateInADayEndTimeHours = "0" + dateInADayEndTimeHours;
                    if (dateInADayEndTimeMins.toString().length < 2) dateInADayEndTimeMins = "0" + dateInADayEndTimeMins;

                    const dateInADayEndTimeFormat = `${dateInADayEndTimeYear}-${dateInADayEndTimeMonth}-${dateInADayEndTimeDate}T${dateInADayEndTimeHours}:${dateInADayEndTimeMins}`;

                    if (isFlatFee) {
                        shiftsToAdd.push({
                            chosenClient, chosenCaretaker, startTimeSecs,
                            startDatetime: dateInADayFormat, endDatetime: dateInADayEndTimeFormat,
                            shiftComments, caretakerColor, shiftRepeat: true, shiftRepeatID,
                            isFlatFeeShift: true, flatFeeCaretaker, shiftMileage, flatFeeClient
                        });
                    } else {
                        shiftsToAdd.push({
                            chosenClient, chosenCaretaker, startTimeSecs,
                            startDatetime: dateInADayFormat, endDatetime: dateInADayEndTimeFormat,
                            shiftComments, caretakerColor, shiftRepeat: true, shiftRepeatID,
                            isFlatFeeShift: false, flatFeeCaretaker: null, shiftMileage, flatFeeClient: null
                        });
                    }
                }
            }
        } else {
            if (isFlatFee) {
                shiftsToAdd.push({
                    chosenClient, chosenCaretaker, startTimeSecs,
                    startDatetime, endDatetime,
                    shiftComments, caretakerColor, shiftRepeat: false, shiftRepeatID: null,
                    isFlatFeeShift: true, flatFeeCaretaker, shiftMileage, flatFeeClient
                });
            } else {
                shiftsToAdd.push({
                    chosenClient, chosenCaretaker, startTimeSecs,
                    startDatetime, endDatetime,
                    shiftComments, caretakerColor, shiftRepeat: false, shiftRepeatID: null,
                    isFlatFeeShift: false, flatFeeCaretaker: null, shiftMileage, flatFeeClient: null
                });
            }
        }

        try {
            await props.addShift(shiftsToAdd);
            alert("Shifts added successfully");
            resetForm();
        } catch (err) {
            console.error('Failed to add shift:', err);
            alert('Error saving shift: ' + (err?.message || 'Unknown error. Check console for details.'));
        }
    }

    const resetForm = () => {
        setClient('');
        setCaretaker('');
        setStartDate('');
        setStartTime('');
        setEndDate('');
        setEndTime('');
        setComments('');
        setMileage('');
        setFlatFeeCaretaker('');
        setFlatFeeClient('');
        setEndTimeError('');
        props.setRenderFlatFeeOptions(false);
        props.setRenderRepeatOptions(false);

        // Clear uncontrolled RepeatOptions inputs
        const repeatEndDate = document.getElementById('repeatEndDate');
        if (repeatEndDate) repeatEndDate.value = '';
        const repeatFreq = document.getElementById('repeatFreqSelect');
        if (repeatFreq) repeatFreq.value = 'Weekly';
        ['mondayRepeat','tuesdayRepeat','wednesdayRepeat','thursdayRepeat','fridayRepeat','saturdayRepeat','sundayRepeat']
            .forEach(id => {
                const el = document.getElementById(id);
                if (el) el.checked = false;
            });
    }

    return(
        <div className="addShiftBoxDiv" id="addShiftBoxDiv">
            <a name="addShiftTarget"></a>
            <h2 id="addShiftH2">Add Shift</h2>
            <div className="formSep"></div>
            <div className="addShiftFormDiv">

                <div className="optionSelectDiv" id="clientDiv">
                    <label htmlFor="clientSelect">Client: </label>
                    <select id="clientSelect" value={client} onChange={e => setClient(e.target.value)}>
                        <option value="">-- Select Client --</option>
                        {sortedClients.map(c => (
                            <option key={c.name} value={c.name}>{c.name}</option>
                        ))}
                    </select>
                </div>

                <div className="optionSelectDiv" id="caretakerDiv">
                    <label htmlFor="caretakerSelect">Caretaker: </label>
                    <select id="caretakerSelect" value={caretaker} onChange={e => setCaretaker(e.target.value)}>
                        <option value="">-- Select Caretaker --</option>
                        {sortedCaretakers.map(c => (
                            <option key={c.name} value={c.name}>{c.name}</option>
                        ))}
                    </select>
                </div>

                <div className="optionSelectDiv" id="shiftStartDateDiv">
                    <label htmlFor="shiftStartDate">Start Date: </label>
                    <input
                        type="date" id="shiftStartDate" name="shiftStartDate"
                        value={startDate}
                        onChange={e => { setStartDate(e.target.value); setEndDate(e.target.value); }}
                    />
                </div>

                <div className="optionSelectDiv" id="shiftStartTimeDiv">
                    <label htmlFor="shiftStartTime">Start Time: </label>
                    <input
                        type="time" id="shiftStartTime" name="shiftStartTime"
                        value={startTime}
                        onChange={e => { setStartTime(e.target.value); setEndTimeError(''); }}
                    />
                </div>

                <div className="optionSelectDiv" id="shiftEndDateDiv">
                    <label htmlFor="shiftEndDate">End Date: </label>
                    <input
                        type="date" id="shiftEndDate" name="shiftEndDate"
                        value={endDate}
                        onChange={e => { setEndDate(e.target.value); setEndTimeError(''); }}
                    />
                </div>

                <div className="optionSelectDiv" id="shiftEndTimeDiv">
                    <label htmlFor="shiftEndTime">End Time: </label>
                    <input
                        type="time" id="shiftEndTime" name="shiftEndTime"
                        value={endTime}
                        onChange={e => { setEndTime(e.target.value); setEndTimeError(''); }}
                    />
                </div>

                {endTimeError && (
                    <div className="endTimeError">{endTimeError}</div>
                )}

                <label htmlFor="shiftComments">Comments: </label>
                <textarea
                    id="shiftComments" name="shiftComments"
                    placeholder="Enter any short comments here"
                    value={comments}
                    onChange={e => setComments(e.target.value)}
                />

                <label htmlFor="mileage">Mileage Distance: </label>
                <input
                    type="number" name="mileage" id="mileage"
                    value={mileage}
                    onChange={e => setMileage(e.target.value)}
                />

                <button
                    id="flatFeeSelect"
                    className={props.renderFlatFeeOptions ? 'toggleBtn toggleBtn--active' : 'toggleBtn'}
                    onClick={() => props.setRenderFlatFeeOptions(v => !v)}
                >
                    Flat Fee?
                </button>

                {props.renderFlatFeeOptions && (
                    <div id="flatFeeOptionsDiv">
                        <div className="optionSelectDiv">
                            <label htmlFor="flatFeeInputCaretaker">Flat Fee Amount - Caretaker: </label>
                            <input
                                id="flatFeeInputCaretaker" type="number"
                                value={flatFeeCaretaker}
                                onChange={e => setFlatFeeCaretaker(e.target.value)}
                            />
                        </div>
                        <div className="optionSelectDiv">
                            <label htmlFor="flatFeeInputClient">Flat Fee Amount - Client: <span style={{fontWeight:'normal',fontSize:'0.85em',color:'#666'}}>(optional — leave blank to bill client hourly)</span></label>
                            <input
                                id="flatFeeInputClient" type="number"
                                value={flatFeeClient}
                                onChange={e => setFlatFeeClient(e.target.value)}
                            />
                        </div>
                    </div>
                )}

                <button
                    id="repeatSelect"
                    className={props.renderRepeatOptions ? 'toggleBtn toggleBtn--active' : 'toggleBtn'}
                    onClick={() => props.setRenderRepeatOptions(v => !v)}
                >
                    Repeating Shift?
                </button>

            </div>

            {props.renderRepeatOptions && (
                <div id="repeatShiftOptionsDiv">
                    <RepeatOptions />
                </div>
            )}

            <Button onClick={() => gatherFields()}
                type="button"
                buttonStyle="btn--success--solid"
                buttonSize="btn--medium"
            >
                Confirm Shift
            </Button>

        </div>
    )
}
